import { Button, Form, Input, Space, Table } from "antd"
import { useReducer, useState } from "react";
import { ViewItem, buildStateForSave, createViewItems, defaultItemCategoriesState, hasChanges } from "./itemCategoriesModel";
import { faFloppyDisk } from "@fortawesome/pro-solid-svg-icons";
import { useItemCategories, useSaveItemCategoriesMutation } from "./itemCategoriesQueries";
import { DeleteButton } from "../../common/DeleteButton";
import { reducer } from "./itemCategoriesReducer";
import { UndeleteButton } from "../../common/UndeleteButton";
import { styleDeletedRows } from '../../Items/styleDeletedRows'
import IconAndTextButton from "../../IconAndTextButton";

const StyledTable = styleDeletedRows<typeof Table<ViewItem>>(Table)

const ItemCategoriesForm = () => {
  const [state, dispatch] = useReducer(reducer, defaultItemCategoriesState())
  const [newItemCategoryName, setNewItemCategoryName] = useState('')
  const itemCategoriesQuery = useItemCategories()
  const serverItemCategories = itemCategoriesQuery.data ?? []
  const viewItems: ViewItem[] = createViewItems(state, serverItemCategories)
  const hasStateChanges = hasChanges(state)
  const saveItemCategoriesMutation = useSaveItemCategoriesMutation(() => {
    dispatch({ type: 'ITEM_CATEGORIES_SAVE' })
  })
  const [form] = Form.useForm()

  return <>
    <Form layout="vertical" form={form}>
      <Form.Item style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <IconAndTextButton type="primary" size="large" disabled={!hasStateChanges}
          onClick={() => { saveItemCategoriesMutation.mutate({ changeSet: buildStateForSave(state) }) }}
          icon={faFloppyDisk} text="Save" />
      </Form.Item>
      <Form.Item label="Item Category">
        <Input placeholder="Enter your new item category"
          value={newItemCategoryName}
          maxLength={45}
          onChange={e => setNewItemCategoryName(e.target.value)}
        />
      </Form.Item>
      <Form.Item>
        <Space>
          <Button
            type="primary"
            size="large"
            onClick={() => {
              dispatch({ type: 'ITEM_CATEGORY_ADDED', value: newItemCategoryName })
              setNewItemCategoryName('')
            }}
          >
            Add Item Category
          </Button>
        </Space>
      </Form.Item>
      <Form.Item>
        <StyledTable
          dataSource={viewItems}
          rowKey='id'
          rowClassName={(item: ViewItem) => item.isDeleted ? 'deleted' : ''}
          pagination={false}
          columns={[
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name',
              render: (_, { name, id, isDeleted }) => (
                <>
                  <Input
                    value={name}
                    maxLength={45}
                    onChange={e => dispatch({ type: 'ITEM_CATEGORY_CHANGED', serverItemCategories: serverItemCategories ?? [], value: e.target.value, itemCategoryId: id })}
                    disabled={isDeleted}
                  />
                </>
              ),
            },
            {
              align: 'right',
              render: (_, item) => {
                return item.isDeleted
                  ? <UndeleteButton onClick={() => {
                    dispatch({ type: 'ITEM_CATEGORY_UNDELETED', itemCategoryId: item.id })
                  }} />
                  : <DeleteButton onClick={() => {
                    dispatch({ type: 'ITEM_CATEGORY_DELETED', itemCategoryId: item.id })
                  }} />
              }
            }
          ]}
        />
      </Form.Item>
    </Form>
  </>
}

export default ItemCategoriesForm
